<div style="background-color: #f7f7f7;">
  <div class="header" [ngStyle]="properties.length > 0 ? {'margin-bottom':'10rem'} : {'margin-bottom':'7rem'}" style="background-color: #35566E; width: 100%;position: sticky; top: 0; z-index: 2;">
    <div class="columns header" style="align-items: center; z-index: 2;">
      <div class="column is-1">
        <svg id="docestate_logo" style="cursor: pointer; padding-left: 10px;padding-top: 5px" routerLink="/home"
             xmlns="http://www.w3.org/2000/svg" width="73.608" height="66.645" viewBox="0 0 73.608 66.645">
          <g id="Gruppe_9" data-name="Gruppe 9" transform="translate(-741.959 -195.536)">
            <g id="Docestate-weiß" transform="translate(741.959 195.536)">
              <path id="Pfad_1" data-name="Pfad 1" d="M333.6,695.2v1.41l5.95,2.28v-1.916Z" transform="translate(-322.233 -654.635)" fill="#fff"/>
              <path id="Pfad_2" data-name="Pfad 2" d="M333.6,653.723V652.3l5.95.753v1.9Z" transform="translate(-322.233 -614.522)" fill="#fff"/>
              <path id="Pfad_3" data-name="Pfad 3" d="M339.55,605.5v1.838l-5.95-.175V605.63Z" transform="translate(-322.233 -570.762)" fill="#fff"/>
              <path id="Pfad_4" data-name="Pfad 4" d="M339.55,547.623l-5.95.734V546.98l5.95-1.28Z" transform="translate(-322.233 -514.846)" fill="#fff"/>
              <path id="Pfad_5" data-name="Pfad 5" d="M339.55,488.842l-5.95,1.747V489.2l5.95-2.3Z" transform="translate(-322.233 -459.865)" fill="#fff"/>
              <path id="Pfad_6" data-name="Pfad 6" d="M333.6,431.887l5.95-2.787v-2l-5.95,3.384Z" transform="translate(-322.233 -403.95)" fill="#fff"/>
              <path id="Pfad_7" data-name="Pfad 7" d="M333.6,353.388l5.95-3.9V346.1l-5.95,5.534Z" transform="translate(-322.233 -328.211)" fill="#fff"/>
              <path id="Pfad_8" data-name="Pfad 8" d="M437.7,338.4v3.586l3.709,1.682v-2.884Z" transform="translate(-419.571 -321.011)" fill="#fff"/>
              <path id="Pfad_9" data-name="Pfad 9" d="M437.7,421.1l3.709,1.513v1.7L437.7,423.1Z" transform="translate(-419.571 -398.34)" fill="#fff"/>
              <path id="Pfad_10" data-name="Pfad 10" d="M437.7,482.3l3.709,1.241v1.624l-3.709-.877Z" transform="translate(-419.571 -455.564)" fill="#fff"/>
              <path id="Pfad_11" data-name="Pfad 11" d="M437.1,543.7l3.748.65v1.728l-3.748-.37Z" transform="translate(-419.01 -512.976)" fill="#fff"/>
              <path id="Pfad_12" data-name="Pfad 12" d="M437.1,604.6l3.748.175v1.773H437.1Z" transform="translate(-419.01 -569.92)" fill="#fff"/>
              <path id="Pfad_13" data-name="Pfad 13" d="M437.1,661.386l3.748-.286v1.7l-3.748.513Z" transform="translate(-419.01 -622.75)" fill="#fff"/>
              <path id="Pfad_14" data-name="Pfad 14" d="M437.1,714.818l3.748-.818v1.78l-3.748,1.059Z" transform="translate(-419.01 -672.214)" fill="#fff"/>
              <path id="Pfad_15" data-name="Pfad 15" d="M1039.8,696.394v2l9.263-2.624V694.4Z" transform="translate(-982.561 -653.887)" fill="#fff"/>
              <path id="Pfad_16" data-name="Pfad 16" d="M1039.8,655.409l9.263-1.325V652.7l-9.263.708Z" transform="translate(-982.561 -614.896)" fill="#fff"/>
              <path id="Pfad_17" data-name="Pfad 17" d="M1039.8,604l9.263.422v1.384l-9.263.13Z" transform="translate(-982.561 -569.359)" fill="#fff"/>
              <path id="Pfad_18" data-name="Pfad 18" d="M1039.8,542.6l9.263,1.7v1.4l-9.263-1.143Z" transform="translate(-982.561 -511.947)" fill="#fff"/>
              <path id="Pfad_19" data-name="Pfad 19" d="M1039.8,482.507l9.263,2.338v-1.28L1039.8,480.5Z" transform="translate(-982.561 -453.881)" fill="#fff"/>
              <path id="Pfad_20" data-name="Pfad 20" d="M1039.8,419.7l9.263,3.819v1.423l-9.263-3.209Z" transform="translate(-982.561 -397.03)" fill="#fff"/>
              <path id="Pfad_21" data-name="Pfad 21" d="M1039.8,337.2l9.263,6.021v1.773l-9.263-4.248Z" transform="translate(-982.561 -319.889)" fill="#fff"/>
              <path id="Pfad_22" data-name="Pfad 22" d="M955.869,345.9v3.332l-4.677,3.046-.292-1.734Z" transform="translate(-899.436 -328.024)" fill="#fff"/>
              <path id="Pfad_23" data-name="Pfad 23" d="M960.264,426.7v1.871l-4.664,2.286v-1.494Z" transform="translate(-903.83 -403.576)" fill="#fff"/>
              <path id="Pfad_24" data-name="Pfad 24" d="M960.264,486v1.877l-4.664,1.442v-1.5Z" transform="translate(-903.83 -459.024)" fill="#fff"/>
              <path id="Pfad_25" data-name="Pfad 25" d="M955.6,546.607l4.664-1.007v1.845l-4.664.585Z" transform="translate(-903.83 -514.752)" fill="#fff"/>
              <path id="Pfad_26" data-name="Pfad 26" d="M955.6,604.195l4.664-.195v1.864l-4.664-.188Z" transform="translate(-903.83 -569.359)" fill="#fff"/>
              <path id="Pfad_27" data-name="Pfad 27" d="M955.6,653.6l4.664.552v1.936l-4.664-1.007Z" transform="translate(-903.83 -615.737)" fill="#fff"/>
              <path id="Pfad_28" data-name="Pfad 28" d="M955.6,700l4.664,1.4v1.942l-4.664-1.825Z" transform="translate(-903.83 -659.123)" fill="#fff"/>
              <path id="Pfad_29" data-name="Pfad 29" d="M687.9,343v33.309l17.389-5.028V347.833Zm1.89,4.125a.184.184,0,0,1,.227-.143l8.2,1.786a.184.184,0,0,1,.143.227.186.186,0,0,1-.182.149.082.082,0,0,1-.039-.007l-8.2-1.786A.187.187,0,0,1,689.79,347.125Zm8.568,4.079a.189.189,0,0,1-.188.156h-.032l-8.2-1.41a.191.191,0,0,1,.065-.377l8.2,1.416A.188.188,0,0,1,698.358,351.2Zm0,2.17a.184.184,0,0,1-.188.162h-.026l-8.2-1.072a.19.19,0,0,1,.052-.377l8.2,1.072A.194.194,0,0,1,698.358,353.373Zm4.9,14.368L690,370.1h-.032a.194.194,0,0,1-.188-.156.191.191,0,0,1,.156-.221l13.257-2.358a.191.191,0,0,1,.221.156A.188.188,0,0,1,703.262,367.742Zm-13.316-.578,13.257-1.793a.19.19,0,1,1,.052.377L690,367.54h-.026a.2.2,0,0,1-.188-.162A.19.19,0,0,1,689.946,367.164Zm-.162-2.377a.194.194,0,0,1,.169-.208l13.258-1.208a.189.189,0,0,1,.208.169.194.194,0,0,1-.169.208l-13.257,1.208h-.019A.19.19,0,0,1,689.784,364.786Zm13.459-2.962-13.257.643h-.007a.192.192,0,0,1-.188-.182.185.185,0,0,1,.182-.195l13.257-.643a.185.185,0,0,1,.195.182A.193.193,0,0,1,703.243,361.824Zm-.013-1.962H689.972a.188.188,0,1,1,0-.377H703.23a.188.188,0,0,1,0,.377Z" transform="translate(-653.519 -325.313)" fill="#fff"/>
              <path id="Pfad_30" data-name="Pfad 30" d="M505.868,746.415V742.83L494.8,739.4v2.657Z" transform="translate(-472.962 -695.964)" fill="#fff"/>
              <path id="Pfad_31" data-name="Pfad 31" d="M494.8,661.1l11.069,1.371v3.547L494.8,663.64Z" transform="translate(-472.962 -622.75)" fill="#fff"/>
              <path id="Pfad_32" data-name="Pfad 32" d="M494.8,575.659l11.069.461V572.6l-11.069.5Z" transform="translate(-472.962 -539.999)" fill="#fff"/>
              <path id="Pfad_33" data-name="Pfad 33" d="M494.8,464.677l11.069-2.377v3.579L494.8,467.328Z" transform="translate(-472.962 -436.863)" fill="#fff"/>
              <path id="Pfad_34" data-name="Pfad 34" d="M494.8,355.917l11.069-4.417v3.56l-11.069,3.4Z" transform="translate(-472.962 -333.26)" fill="#fff"/>
              <path id="Pfad_35" data-name="Pfad 35" d="M494.8,238l12.543-6,17.389,6v-2.637L507.343,228.2,494.8,235.358Z" transform="translate(-472.962 -217.969)" fill="#fff"/>
              <path id="Pfad_36" data-name="Pfad 36" d="M494.8,85.562l12.543-7.847,17.389,7.847V82.191L507.343,70.7,494.8,82.269Z" transform="translate(-472.962 -70.7)" fill="#fff"/>
              <path id="Pfad_37" data-name="Pfad 37" d="M158.6,935.091V924.444a14.358,14.358,0,0,1,1.656-.253c.6-.058,1.169-.091,1.715-.091a6.641,6.641,0,0,1,4.592,1.4,5.382,5.382,0,0,1,1.552,4.2,5.233,5.233,0,0,1-1.6,4.209,7.245,7.245,0,0,1-4.82,1.371A24.021,24.021,0,0,1,158.6,935.091Zm7-1.968a5.476,5.476,0,0,0,0-6.846,5.18,5.18,0,0,0-3.631-1.117,13.474,13.474,0,0,0-2.1.188v8.75a14.879,14.879,0,0,0,2.072.123A5.267,5.267,0,0,0,165.6,933.122Z" transform="translate(-158.6 -868.667)" fill="#fff"/>
              <path id="Pfad_38" data-name="Pfad 38" d="M338,970.719a6.43,6.43,0,0,1,.007-6.561,3.475,3.475,0,0,1,5,0,5,5,0,0,1,.9,3.28,4.946,4.946,0,0,1-.9,3.28,3.475,3.475,0,0,1-5,0Zm4.475-.429a4.508,4.508,0,0,0,.7-2.825,4.644,4.644,0,0,0-.7-2.878,2.668,2.668,0,0,0-3.949-.006,4.509,4.509,0,0,0-.7,2.826,4.644,4.644,0,0,0,.7,2.878,2.668,2.668,0,0,0,3.949.006Z" transform="translate(-325.505 -905.133)" fill="#fff"/>
              <path id="Pfad_39" data-name="Pfad 39" d="M475.161,970.665a6.131,6.131,0,0,1,.013-6.612A3.635,3.635,0,0,1,477.98,963a6.773,6.773,0,0,1,1.832.253v.63a6.329,6.329,0,0,0-1.825-.266,3.543,3.543,0,0,0-1.682.364,2.347,2.347,0,0,0-1.026,1.182,6.9,6.9,0,0,0,.007,4.365A2.32,2.32,0,0,0,476.3,970.7a3.43,3.43,0,0,0,1.624.351,5.291,5.291,0,0,0,.922-.078,7.226,7.226,0,0,0,.961-.247v.624a5.635,5.635,0,0,1-1.923.318A3.554,3.554,0,0,1,475.161,970.665Z" transform="translate(-453.7 -905.04)" fill="#fff"/>
              <path id="Pfad_40" data-name="Pfad 40" d="M594.46,935.677h6.483V936.7H593.2v-11h7.671v1.026h-6.4v3.819h5.645v1.02h-5.645v4.112Z" transform="translate(-564.97 -870.163)" fill="#fff"/>
              <path id="Pfad_41" data-name="Pfad 41" d="M745.317,971.594a6.08,6.08,0,0,1-1-.247v-.623a6.335,6.335,0,0,0,2.033.344,2.63,2.63,0,0,0,1.643-.429,1.513,1.513,0,0,0,.546-1.267,1.369,1.369,0,0,0-.747-1.325,4.473,4.473,0,0,0-1.052-.383l-.409-.1a3.309,3.309,0,0,1-1.6-.831,2.006,2.006,0,0,1-.526-1.448,2.237,2.237,0,0,1,.325-1.221,2.016,2.016,0,0,1,.974-.786A4.09,4.09,0,0,1,747.09,963a6.638,6.638,0,0,1,.948.065,5.212,5.212,0,0,1,.857.195v.617a6.038,6.038,0,0,0-1.806-.266,2.666,2.666,0,0,0-1.637.416,1.436,1.436,0,0,0-.546,1.215,1.623,1.623,0,0,0,.162.773,1.364,1.364,0,0,0,.526.526,3.965,3.965,0,0,0,.987.383l.409.1a3.718,3.718,0,0,1,1.708.844,1.97,1.97,0,0,1,.546,1.455,2.321,2.321,0,0,1-.338,1.28,2.117,2.117,0,0,1-.994.8,4.091,4.091,0,0,1-1.578.273A6.168,6.168,0,0,1,745.317,971.594Z" transform="translate(-706.162 -905.04)" fill="#fff"/>
              <path id="Pfad_42" data-name="Pfad 42" d="M846.258,973.07v-7.847H843.4V964.6h6.411v.624h-2.858v7.847Z" transform="translate(-798.918 -906.536)" fill="#fff"/>
              <path id="Pfad_43" data-name="Pfad 43" d="M961.37,973.07l-1.039-2.865h-3.683l-1.039,2.865H954.9l3.118-8.47h.955l3.118,8.47Zm-4.5-3.469h3.241l-1.617-4.449Z" transform="translate(-903.176 -906.536)" fill="#fff"/>
              <path id="Pfad_44" data-name="Pfad 44" d="M1084.158,973.07v-7.847H1081.3V964.6h6.411v.624h-2.858v7.847Z" transform="translate(-1021.365 -906.536)" fill="#fff"/>
              <path id="Pfad_45" data-name="Pfad 45" d="M1213.695,972.46h4.424v.611H1213V964.6h5.06v.61h-4.365v3.2h3.82v.6h-3.82Z" transform="translate(-1144.51 -906.536)" fill="#fff"/>
            </g>
          </g>
        </svg>
      </div>
      <div class="column is-2 has-text-centered">
      </div>
      <div class="column is-4" style="padding-right: 0">
        <div style="position: relative">
          <input class="input" type="text" placeholder="  Bestandsobjekte suchen" [(ngModel)]="searchText" (keyup)="setFoundSavedProperty()" [disabled]="!isAllowedToOrder"
                 style="border-radius: 15px 0 0 15px !important;height: 50px; padding: 10px;z-index: 4;border-bottom: none !important;box-shadow: 0 0.5em 1em -0.125em rgba(10,10,10,0.1), 0 0 0 1px rgba(10,10,10,0.02) !important;">

          <div *ngIf="searchText" class="card" style="position:absolute; width: 100%;z-index: 3; margin-left: 5px; margin-top: -5%;padding-top: 2rem">
            <table class="table result-table" id="result-table" style="width: 100%">
              <thead>
              <tr [ngClass]="{'is-hidden': !foundSavedProperty || !searchText}">
                <th scope="col">ID</th>
                <th scope="col">Ort</th>
                <th scope="col">Straße</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngIf="!loadingSavedProperties" [ngClass]="{'is-hidden': foundSavedProperty || !searchText}">
                <td colspan="3">Kein Objekt gefunden</td>
              </tr>
              <ng-container *ngIf="!loadingSavedProperties">
                  <ng-container *ngFor="let savedProperty of savedProperties | search: searchText:'existingProperty'">
                      <tr class="is-clickable result-row" (click)="addSavedPropertyToOrder(savedProperty)" *ngIf="(platformProfile.mandate.length > 0 && savedProperty.mandateId === getSelectedMandate()) || platformProfile.mandate.length < 1">
                          <td>{{savedProperty.ownId}}</td>
                          <td>{{savedProperty.town}}</td>
                          <td>{{savedProperty.street}}</td>
                      </tr>
                  </ng-container>
              </ng-container>
              <ng-container *ngIf="loadingSavedProperties">
                  <tr class="result-row" *ngFor="let _ of [].constructor(5)">
                      <td>
                          <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto'}"
                                               animation="progress" appearance="line" count="1">
                          </ngx-skeleton-loader>
                      </td>
                      <td>
                          <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto'}"
                                               animation="progress" appearance="line" count="1">
                          </ngx-skeleton-loader>
                      </td>
                      <td>
                          <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto'}"
                                               animation="progress" appearance="line" count="1">
                          </ngx-skeleton-loader>
                      </td>
                  </tr>
              </ng-container>
              </tbody>
            </table>
          </div>
        </div>


      </div>
      <div class="column is-1" style="padding-left: 0; width: 5%">
        <!--Ankaufsobjekt hinzufügen-->
        <button class="button buy-button is-size-7 has-round-border" style="border: none; height: 50px; border-radius: 0 15px 15px 0 !important; background-color: #73B1D6 !important;" (click)="isAllowedToOrder ? openModal() : $event.stopPropagation()">
          <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="21.043" height="21.043" viewBox="0 0 21.043 21.043">
            <path id="Icon_awesome-plus" data-name="Icon awesome-plus" d="M19.54,10.517H12.776V3.753a1.5,1.5,0,0,0-1.5-1.5H9.77a1.5,1.5,0,0,0-1.5,1.5v6.764H1.5A1.5,1.5,0,0,0,0,12.02v1.5a1.5,1.5,0,0,0,1.5,1.5H8.267V21.79a1.5,1.5,0,0,0,1.5,1.5h1.5a1.5,1.5,0,0,0,1.5-1.5V15.026H19.54a1.5,1.5,0,0,0,1.5-1.5v-1.5A1.5,1.5,0,0,0,19.54,10.517Z" transform="translate(0 -2.25)" fill="#ffffff"/>
          </svg>
        </button>
      </div>
      <div class="column is-3">
        <app-company-login-selection></app-company-login-selection>
      </div>
      <div class="column is-2" style="width: 11%">
        <div class="navbar-item is-hoverable" *ngIf="this.user">
          <a class="navbar-link" >
            <svg xmlns="http://www.w3.org/2000/svg" width="32.41" height="32.41" viewBox="0 0 42.41 42.41">
              <path id="Icon_material-account-circle" data-name="Icon material-account-circle" d="M24.2,3a21.2,21.2,0,1,0,21.2,21.2A21.213,21.213,0,0,0,24.2,3Zm0,6.361a6.361,6.361,0,1
          1-6.361,6.361A6.353,6.353,0,0,1,24.2,9.361Zm0,30.111a15.269,15.269,0,0,1-12.723-6.828c.064-4.22,8.482-6.531,12.723-6.531,4.22,0,12.659,2.311,12.723,6.531A15.269,15.269,0
          01,24.2,39.472Z" transform="translate(-3 -3)" fill="#ffffff"/>
            </svg>

          </a>
          <div class="navbar-dropdown"  >
            <a routerLink="/new_order" class="navbar-item no-warning">
              Neue Bestellung
            </a>
            <a routerLink="/order" class="navbar-item no-warning">
              Meine Bestellungen
            </a>
            <a routerLink="/account" class="navbar-item no-warning">
              Konto
            </a>
            <hr class="navbar-divider">
            <a routerLink="/order_permissions" class="navbar-item no-warning">
              Berechtigungen
            </a>
            <a routerLink="/user_group_management" class="navbar-item no-warning">
              Nutzerverwaltung
            </a>
            <hr class="navbar-divider">
            <a routerLink="/batch-download" class="navbar-item no-warning">
              Downloads
            </a>
            <hr class="navbar-divider">
            <a (click)="logout()" class="navbar-item no-warning">
              Abmelden
            </a>
          </div>

        </div>
      </div>

    </div>
    <div *ngIf="properties.length > 0" [@inOutAnimation] id="added-properties" class="columns is-flex-wrap-wrap" [ngStyle]="properties.length > 12 ? {'border-radius':'0 0 10px 45px'} : {'border-radius':'0 0 45px 45px'}"
         style="background-color: #35566E;align-items: center;margin-top: -1rem; width: 100%; margin-left: 0;position:absolute;max-height: 150px;overflow: auto">
      <div class="column is-2 is-bold" style="color: white; padding-left: 22px">Ausgewählte Objekte:</div>
      <div class="column is-10">
      </div>
      <ng-container *ngFor="let property of properties">

        <div [ngClass]="{'active': isPropertyLoaded(property)}" class="column is-one-quarter has-round-border card is-clickable property"  style="width: 23%; border: 25px">
          <div class="columns">
            <div class="column is-one-fifth" style="display: flex;align-items: center;justify-content: start; padding-top: 5px; padding-bottom: 0;padding-left: 1rem;width: 7%">
              <div (click)="removePropertyFromPropertyList(property)">
                <svg xmlns="http://www.w3.org/2000/svg" width="14.103" height="14.178" viewBox="0 0 14.103 14.178">
                  <path id="Icon_metro-cross" data-name="Icon metro-cross" d="M16.545,13.318h0l-4.278-4.3,4.278-4.3h0a.44.44,0,0,0,.1-.158.445.445,0,0,0-.1-.468L14.524,2.057a.44.44,0,0,0-.623,0h0l-4.278,4.3-4.278-4.3h0a.44.44,0,0,0-.623,0L2.7,4.089a.446.446,0,0,0,0,.626h0l4.278,4.3L2.7,13.318h0a.446.446,0,0,0,0,.626l2.021,2.032a.44.44,0,0,0,.623,0h0l4.278-4.3,4.278,4.3h0a.44.44,0,0,0,.623,0l2.021-2.032a.446.446,0,0,0,0-.626Z" transform="translate(-2.571 -1.928)" fill="#707070"/>
                </svg>

              </div>
            </div>
            <div class="column is-9">
              <div style="font-weight: bold; color: #707070 !important;" (click)="onPropertySelection(property)">
                <p  [ngClass]="{'active': isPropertyLoaded(property)}">{{property.name}}</p>
              </div>
            </div>
            <div (click)="openPropertyInformationModal(property)" class="column card property is-clickable" style="background-color: #73B1D6;display: flex;justify-content: center;align-items: center;padding-top: 0.5rem;padding-right: 0.5rem">
                <svg xmlns="http://www.w3.org/2000/svg" width="7.514" height="15.964" viewBox="0 0 7.514 15.964">
                  <path id="Icon_awesome-info" data-name="Icon awesome-info" d="M.783,13.225h.783v-4.5H.783A.717.717,0,0,1,0,8.1V6.609a.717.717,0,0,1,.783-.624H5.166a.717.717,0,0,1,.783.623v6.616h.783a.717.717,0,0,1,.783.623v1.489a.717.717,0,0,1-.783.623H.783A.717.717,0,0,1,0,15.338v-1.49a.717.717,0,0,1,.783-.623ZM3.757,0A2.581,2.581,0,0,0,.939,2.245,2.581,2.581,0,0,0,3.757,4.489,2.581,2.581,0,0,0,6.577,2.245,2.581,2.581,0,0,0,3.757,0Z" fill="#fefbfb"/>
                </svg>
            </div>
          </div>

        </div>
      </ng-container>
    </div>

  </div>

  <div class="container is-widescreen">
    <app-notification *ngIf="this.errorMsg != null" [content]="this.errorMsg" (notificationClosed)="this.errorMsg = null"  timeOut="0" display="true" ignoreOffset="true"
                      error=true></app-notification>
    <div class="columns" *ngIf="platformProfile && platformProfile.mandate.length > 0">
      <div class="column is-5"></div>
      <div class="column">
        <div  class="is-clickable" *ngIf="getMandateNameById() !== ''" (click)="showMandateModal = true" style="display: flex;justify-content: center; align-items: center; height: 65px">
          <ng-container *ngIf="platformProfile">
            <ng-container *ngFor="let mandate of platformProfile.mandate">
              <div *ngIf="mandate.id === getSelectedMandate()">
                <img alt="{{mandate.name}}" src="{{mandate.s3Key}}">
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="column is-5"></div>
    </div>

    <app-notification *ngIf="showMissingPropertyError" (notificationClosed)="showMissingPropertyError=false" content="Bitte wählen Sie ein Objekt aus." ignoreOffset="true" timeOut="0" display="true"
                      error=true></app-notification>
    <app-notification id="not-allowed-to-order" *ngIf="!isAllowedToOrder" content="Sie sind nicht berechtigt Bestellungen innerhalb dieser Gesellschaft aufzugeben." ignoreOffset="true" timeOut="0" display="true"
                      error="true" [locked]="true"></app-notification>

    <app-products-container [isConnectOrigin]="true" (infoRequest)="displayInfoEvent($event)"
                            (checkProperty)="checkIfPropertyIsSelected()" (getSelectedProperty)="getSelectedProperty()"
                            [user]="user" [isAllowedToOrder]="isAllowedToOrder"></app-products-container>

    <div class="columns">
      <div class="column is-3">
        <a (click)="back()" class="button back-button is-size-6 has-round-border" style="border:none;display: block !important;">
            <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
              <div class="column is-one-fifth">
                <img alt="Arrow Left" src="assets/images/button/left_btn.svg">
              </div>
              <div class="column">
                <p class="is-bold" style="padding-right: 2rem; padding-bottom: 10px;">Zurück</p>
              </div>
            </div>
        </a>
      </div>
      <div class="column is-6">
      </div>
      <div class="column is-3">
        <a (click)="handleSummaryClickEvent($event)" [ngClass]="{'disabled': !checkIfAllProductInformationArePresent()}" class="button buy-button is-size-6 has-round-border" style="border:none; display: block!important;">
            <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
              <div class="column is-bold"><p style="padding-left: 2rem; padding-bottom: 10px">Zusammenfassung</p></div>
              <div class="column is-one-fifth">
                <img alt="Arrow Right" src="assets/images/button/right_btn.svg">
              </div>
            </div>
        </a>
      </div>
    </div>

    <!--Ankaufsobjekt hinzufügen-->
    <div>
      <app-modal id="authority-modal" [closeable]="false" [active]="showAddPropertyModal" (modalClosed)="closeModal()" #addPropertyModal [width]="window.innerWidth * 0.75">
        <div class="title is-4 has-text-centered is-bold" style="color: #35566E !important;">Ankaufsobjekt hinzufügen</div>
        <app-notification *ngIf="this.addPropertyErrorMsg != null" [content]="this.addPropertyErrorMsg" timeOut="0" display="true" ignoreOffset="true"
                          error=true></app-notification>
        <div>
          <app-property-form [property]="property" [toNextPage]="toNextPage" [showCheckbox]="true" [shouldHaveLandregisterValidators]="true"></app-property-form>
        </div>
        <div class="columns">
          <div class="column">
            <form *ngIf="billingForm" id="billingForm" [formGroup]="billingForm">
              <input class="border-input" placeholder="Rechnungsempfänger/Firma" formControlName="firma"
                     [ngClass]="{'has-error': hasError(billingForm?.get('firma'))}">
              <input class="border-input" placeholder="Straße" formControlName="street"
                     [ngClass]="{'has-error': hasError(billingForm?.get('street'))}">
              <div class="columns">
                <div class="column">
                  <input class="border-input" placeholder="PLZ" formControlName="plz"
                         [ngClass]="{'has-error': hasError(billingForm?.get('plz'))}"></div>
                <div class="column">
                  <input class="border-input" placeholder="Stadt" formControlName="town"
                         [ngClass]="{'has-error': hasError(billingForm?.get('town'))}"></div>
              </div>
              <div class="country-select-wrapper">
                <select class="border-input" formControlName="country">
                  <option [ngValue]="" disabled>Land</option>
                  <option *ngFor="let country of countries" [ngValue]="country.name">{{ country.name }}</option>
                </select>
              </div>
            </form>
          </div>
          <div class="column">
            <form *ngIf="beneficiaryForm" id="beneficiaryForm" [formGroup]="beneficiaryForm">
              <input class="border-input" placeholder="Leistungsempfänger/Firma" formControlName="firma"
                     [ngClass]="{'has-error': isBeneficiaryFormPartiallyFilled() && !beneficiaryForm?.get('firma').value && beneficiaryForm?.get('name').touched}">
              <input class="border-input" placeholder="Straße" formControlName="street"
                     [ngClass]="{'has-error': isBeneficiaryFormPartiallyFilled() && !beneficiaryForm?.get('street').value && beneficiaryForm?.get('street').touched}">
              <div class="columns">
                <div class="column is-4">
                  <input class="border-input" placeholder="PLZ" formControlName="plz"
                         [ngClass]="{'has-error': hasError(beneficiaryForm?.get('plz')) || (isBeneficiaryFormPartiallyFilled() && !beneficiaryForm?.get('plz').value && beneficiaryForm?.get('plz').touched)}"></div>
                <div class="column">
                  <input class="border-input" placeholder="Stadt" formControlName="town"
                         [ngClass]="{'has-error': isBeneficiaryFormPartiallyFilled() && !beneficiaryForm?.get('town').value && beneficiaryForm?.get('town').touched}"></div>
              </div>
              <div class="country-select-wrapper">
                <select class="border-input" formControlName="country">
                  <option [ngValue]="" disabled>Land</option>
                  <option *ngFor="let country of countries" [ngValue]="country.name">{{ country.name }}</option>
                </select>
              </div>
            </form>
          </div>
        </div>

        <app-authority-information></app-authority-information>

        <div class="columns p-3 pt-0">
          <div class="column has-border has-round-border">
            <div class="card__box__head color-darkblue">Berechtigtes Interesse</div>
            <app-legitimate-interest-selector [(selectedValue)]="legitimateInterest" (selectionChanged)="toggleAuthorityDropzone($event)"></app-legitimate-interest-selector>
          </div>
        </div>

        <div class="columns mt-4 p-3" [ngClass]="{'is-justify-content-center': !displayAuthorizedDropzone}">
          <div class="column has-border color-darkblue"
               [ngClass]="{'disabled': legitimateInterest === 'init', 'is-8 has-round-border': !displayAuthorizedDropzone, 'is-left-rounded': displayAuthorizedDropzone}">

            <div class="columns">
              <div class="column is-2">
                <div class="title is-4 is-left is-darkblue is-pulled-left">(1)</div>
              </div>
              <div class="column has-text-centered">
                <h1 class="title is-5 is-darkblue has-text-weight-bold is-uppercase is-spaceless">
                  Vollmacht </h1>
                <p class="is-lightblue is-spaced mb-3 is-size-7">Eigentümerpartei an Vertreter + DocEstate GmbH</p>
              </div>
              <div class="column is-2"></div>
            </div>

            <app-dropzone-connect
                #authorityDropzone
                [maxFileSize]="10000000"
                dropzoneImage="assets/images/dropzone/upload-icon2.svg">
            </app-dropzone-connect>

            <div class="columns">
              <div class="column">
                <button *ngIf="legitimateInterest === 'owner'" (click)="downloadAuthorityPdfTemplate()"
                        class="is-clickable color-white has-round-border is-15 has-background-blue no-border is-bold is-pulled-right download-authority-button-padding is-flex is-align-items-center">
                  <span class="is-size-7 mr-2">Vollmachtvorlage</span>
                  <span class="download-icon">
                    <img alt="Download" src="assets/images/download_icon/download_icon.svg" style="height: 1rem;"></span>
                </button>
              </div>
            </div>
          </div>
          <div *ngIf="legitimateInterest !== 'owner'" class="column has-border is-right-rounded color-darkblue" [ngClass]="{'disabled': legitimateInterest === 'init' || legitimateInterest === 'owner'}">

            <div class="columns">
              <div class="column is-2">
                <div class="title is-4 is-darkblue is-pulled-left">(2)</div>
              </div>
              <div class="column has-text-centered">
                <h1 class="title is-5 is-darkblue has-text-weight-bold is-uppercase is-spaceless">
                  Vollmacht </h1>
                <p class="is-lightblue is-spaced mb-3 is-size-7">Vertreter an DocEstate GmbH</p>
              </div>
              <div class="column is-2">

              </div>
            </div>

            <app-dropzone-connect
                #subAuthorityDropzone
                dropzoneImage="assets/images/dropzone/upload-icon2.svg"
                [maxFileSize]="10000000">
            </app-dropzone-connect>

            <div class="columns">
              <div class="column">
                <button *ngIf="legitimateInterest !== 'owner'" (click)="downloadAuthorityPdfTemplate()"
                        class="is-clickable color-white has-round-border is-15 has-background-blue no-border is-bold is-pulled-right download-authority-button-padding is-flex is-align-items-center">
                  <span class="is-size-7 mr-2">Vollmachtvorlage</span>
                  <span class="download-icon">
                    <img alt="Download" src="assets/images/download_icon/download_icon.svg" style="height: 1rem;"></span>
                </button>
              </div>
            </div>
          </div>
        </div>


        <div class="columns mt-4">
          <div class="column is-one-third">
            <a (click)="closeModal()" class="button back-button is-size-6 has-round-border" style="border:none;display: block !important;">
              <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
                <div class="column is-one-fifth" style="padding-right: 0">
                  <img alt="Arrow Left" src="assets/images/button/left_btn.svg">

                </div>
                <div class="column">
                  <p class="is-bold" style="padding-right: 2rem; padding-bottom: 10px ;">Abbrechen</p>
                </div>
              </div>
            </a>
          </div>
          <div class="column is-one-third">
          </div>
          <div class="column is-one-third">
            <a (click)="addAuthority()" class="button buy-button is-size-6 has-round-border" style="border:none; display: block!important;">
              <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
                <div class="column is-bold"><p style="padding-left: 2rem; padding-bottom: 10px;">Weiter</p></div>

                <div class="column is-one-fifth" style="padding-left: 0">
                  <img alt="Arrow Right" src="assets/images/button/right_btn.svg">
                </div>
              </div>
            </a>
          </div>
        </div>
      </app-modal>
    </div>


    <!--Mandate modal-->
    <app-modal *ngIf="platformProfile && platformProfile.mandate" id="mandate-modal" [closeable]="false" [active]="showMandateModal" (modalClosed)="showMandateModal = false" #mandateModal>
        <div class="title is-4 has-text-centered is-bold" style="color: #35566E;">Für welches Mandat wollen Sie eine Bestellung aufgeben?</div>
        <div class="columns is-flex-wrap-wrap is-centered">
          <div class="column is-one-third has-text-centered is-clickable mx-3 my-3" *ngFor="let mandate of platformProfile.mandate" (click)="setMandate(mandate)"
               style="height: 150px; width: 200px; display: flex; align-items: center; justify-content: center">
            <img alt="{{mandate.name}}" src="{{mandate.s3Key}}">
          </div>
        </div>
    </app-modal>

    <app-property-information [informationProperty]="informationProperty" [showPropertyInformationModal]="showPropertyInformationModal" (modalClosed)="showPropertyInformationModal=false"></app-property-information>

  </div>
</div>

<app-modal [active]="displayInfo" (modalClosed)="displayInfo = false">
  <p  [innerHTML]="docInfo | safeHtml"></p>
</app-modal>
